module.exports = __webpack_public_path__ + "img/equipmentRun.89836591.svg";